import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";
import { useField } from "react-final-form";
import { centToDollar } from "utils/tools";

interface IInvoiceInformation {
  setSumInvoicesAmount: any;
}

const InvoiceInformation = ({ setSumInvoicesAmount }: IInvoiceInformation) => {
  const [customerLedgersSelected, setCustomerLedgersSelected] = useState<
    ICustomerLedgerSelected[]
  >([]);

  const accountingDocumentIdsInput = useField("accountingDocumentIds");
  const provider = useDataProvider();

  useEffect(() => {
    if (accountingDocumentIdsInput.input.value !== "") {
      provider
        .getMany(`invoices`, {
          ids: accountingDocumentIdsInput.input.value,
        })
        .then(({ data }: any) => {
          setCustomerLedgersSelected(data);
          setSumInvoicesAmount(
            Number(
              data.reduce(
                (accumulator: any, invoice: any) =>
                  accumulator + invoice.amountDue,
                0
              )
            )
          );
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountingDocumentIdsInput.input.value]);

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Invoice Information</Typography>
        </Grid>

        {customerLedgersSelected.length > 0 && (
          <>
            {customerLedgersSelected.map((customerLedgerSelected, key) => (
              <Grid item xs={4} key={`invoice-information-${key}`}>
                <SanitizedGrid container spacing={0}>
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      Invoice Number: {customerLedgerSelected.number}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      Type Invoice: {customerLedgerSelected.label}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      Description: {customerLedgerSelected.items[0].description}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2">
                      Remaining Amount: $
                      {centToDollar(customerLedgerSelected.amountDue)}
                    </Typography>
                  </Grid>
                </SanitizedGrid>
              </Grid>
            ))}
          </>
        )}
      </SanitizedGrid>
    </>
  );
};
export default InvoiceInformation;
